const value = {
    writeUs: 'Write us at',
    orCall: 'or call',
  };

export default value;
